export default {"src":"/_next/static/media/sanitizer.6cdf5819.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};